
export const capitalizeTheFirstLetterOfEachWord = (words) => {
  if (!words) return;

  const separateWord = words.toLowerCase().split(' ');
  for (let i = 0; i < separateWord.length; i++) {
    separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
      separateWord[i].substring(1);
  }
  return separateWord.join(' ');
};

export const prettifyName = (uglyName) => {
  if (!uglyName) return;
  return capitalizeTheFirstLetterOfEachWord(uglyName.replaceAll('_', ' '));
};
